import dayjs from 'dayjs';
import { useEffect, useMemo, useState } from 'react';

const CURRENT_TIME_REFRESH_INTERVAL = 60 * 1000;

const getCurrentMinuteOfDay = () => dayjs().hour() * 60 + dayjs().minute();

export const useCurrentTimeMinute = (minuteOfDayValues: number[]) => {
  const [nowMinuteOfDay, setNowMinuteOfDay] = useState(getCurrentMinuteOfDay);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setNowMinuteOfDay(getCurrentMinuteOfDay());
    }, CURRENT_TIME_REFRESH_INTERVAL);

    return () => window.clearInterval(timer);
  }, []);

  return useMemo(
    () =>
      minuteOfDayValues.reduce<number | undefined>((nearest, minuteOfDay) => {
        if (nearest === undefined) {
          return minuteOfDay;
        }

        return Math.abs(minuteOfDay - nowMinuteOfDay) < Math.abs(nearest - nowMinuteOfDay) ? minuteOfDay : nearest;
      }, undefined),
    [minuteOfDayValues, nowMinuteOfDay]
  );
};

export const getCurrentTimeMark = (currentTimeLabel: string | number | undefined) => ({
  markLine: {
    symbol: 'none',
    silent: true,
    lineStyle: {
      type: 'solid',
      color: 'rgba(82, 231, 255, 0.72)',
      width: 1,
    },
    label: {
      show: true,
      formatter: '当前时间',
      rotate: 0,
      color: '#FFFFFF',
      backgroundColor: '#1B6873',
      padding: [4, 6],
    },
    data: currentTimeLabel ? [{ xAxis: currentTimeLabel }] : [],
  },
});
